import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { AppConfig } from '../../app.config';
@Component({
  selector: 'app-change-password',
  templateUrl: './change-password.component.html',
  styleUrls: ['./change-password.component.css']
})
export class ChangePasswordComponent implements OnInit {

  constructor(private router: Router,public config: AppConfig) { }

  ngOnInit() {
  }
  
  onSubmitSuccess(event){
   
    this.router.navigate(['']);
  }
}
